export const BREAST_MILK = { id: 'breast_milk', label: 'Solo latte materno' };
export const BREAST_FORMULA_MILK = {
  id: 'breast_formula_milk',
  label: 'Latte materno e formula (latte artificiale)',
};
export const ARTIFICIAL_MILK = { id: 'artificial_milk', label: 'Solo formula (latte artificiale)' };
export const ARTIFICIAL_MILK_WATER = {
  id: 'artificial_milk_water',
  label: 'Latte materno con aggiunta di acqua o altri liquidi diversi dal latte',
};
export const UNDETECTABLE = { id: 'undetectable', label: 'Non rilevabile' };
